import React from 'react';
import A from '../../atoms/A/A';
import SplitRow from 'components/organisms/SplitRow/SplitRow';
import { FAQ } from 'components/pages/pages';
import Txt from 'components/atoms/Txt/Txt';
import Image from 'components/atoms/Image/Image';
import securityImg1 from './assets/security_img_1.png';
import FullWidthCta from 'components/organisms/FullWidthCta/FullWidthCta';

export interface Props {}

const Security: React.FC<Props> = () => {
  return (
    <main className="fadedPageBg">
      <SplitRow
        mobileColumnOrderSwapped
        contentAlignedTop
        isFirstRow
        leftColumn={
          <>
            <Txt component="h1">Reporting security problems</Txt>

            <section>
              <Txt component="p">
                Send urgent or sensitive data reports directly to{' '}
                <a href="mailto:security@qmee.com">security@qmee.com</a>. If necessary, use our
                public key to keep your message safe and please provide us with a secure way to
                respond.
              </Txt>

              <Txt component="p">
                We&apos;ll get back to you as soon as we can, usually within 24 hours to tell you
                the best way to track the status of your issue.
              </Txt>

              <br />
              <Txt component="p">
                <a href="/security.asc">Download public key</a>
              </Txt>

              <Txt component="p">
                <a href="mailto:security@qmee.com">email security@qmee.com</a>
              </Txt>
              <br />

              <Txt component="p">
                For requests that ARE NOT around security or sensitive, email us at{' '}
                <a href="mailto:support@qmee.com">support@qmee.com</a>.
              </Txt>
            </section>
          </>
        }
        rightColumn={<Image src={securityImg1} alt="Reporting security problems" />}
      ></SplitRow>

      <FullWidthCta
        title={<Txt>Frequently Asked Questions</Txt>}
        ctaText="FAQ's"
        ctaLink={FAQ.path}
      >
        Check out our FAQ&apos;s to help with any unanswered questions
      </FullWidthCta>
    </main>
  );
};
export default Security;
